module.exports = __webpack_public_path__ + "img/inway.fae70526.png";